import { gql } from '@apollo/client';
import { IOrder } from '@global/types/types';

interface Address {
  uid?: string;
  wCountry: string;
  gadStateOrProvince: string;
  upaCity: string;
  upaPostcode: string;
  upaLine1: string;
  upaLine2?: string;
  upaEmail?: string;
  upaPhoneNumber: string;
  wFirstName: string;
  wLastName: string;
  wNewAddress: boolean;
}

interface ShippingOption {
  selectedDeliveryOption: string;
  start: string;
  end: string;
}

export interface UPDATE_SHIPPING_INFO_DATA {
  biRelatesTo: IOrder['biRelatesTo'];
  wSelectedDeliveryOption?: IOrder['wSelectedDeliveryOption'];
  deliDeliveryPeriod?: { start: string; end: string };
  pricPrice: IOrder['pricPrice'];
}

export interface UPDATE_SHIPPING_INFORMATION_VARIABLES {
  orderUid: string;
  address: Address;
  shippingOption: ShippingOption;
}

export interface UPDATE_SHIPPING_INFORMATION_RESPONSE {
  wUpdateShipping: {
    result: {
      data: UPDATE_SHIPPING_INFO_DATA;
    };
  };
}

export const UPDATE_SHIPPING_INFORMATION = gql`
  mutation wUpdateShipping(
    $orderUid: String!
    $address: Object!
    $shippingOption: Object!
  ) {
    wUpdateShipping(
      orderUid: $orderUid
      address: $address
      shippingOption: $shippingOption
    )
  }
`;
